import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

/**
 * Atom that selects validation rules from the questionnaire state.
 *
 * This atom only triggers re-renders when the validations array changes.
 * This is useful for components that need validation rules without
 * subscribing to all questionnaire state.
 */
export const questionnaireValidationsAtom = selectAtom(
  questionnaireReducerAtom,
  state => state.validations,
);
